// import the react components
import React, {useEffect, useState, useRef} from "react";
import {useNavigate} from "react-router-dom";
import useNavigation from "./../context/navigation";
import Alerter from "./../components/alerter";
import OuterHeader from "../ui/outer-header";
import Header from "./../ui/registration/header";
import Input from "./../ui/registration/input";
import FormAction from "./../ui/registration/form-action";
import Footer from "./../components/footer";
import {useStateContext} from "./../context/";

// import the api components
import axios from "axios";
import {USER_API} from "./../assets/data/api";

// initiate the forgot inputs
import {forgot_fields} from "./../assets/data/registration";
let fields = forgot_fields;
let field_state = {};
fields.forEach(field => field_state[field.id] = "");

// the forgot functional based component
const Forgot = () => {
    const {set_alert, set_is_disable} = useStateContext();
    const [forgot, set_forgot] = useState(field_state);
    const [stage, set_stage] = useState(1);
    const [is_disabled_resend, set_is_disabled_resend] = useState(true);
    const timer_ref = useRef(null);
    useNavigation();

    // prepare the inputs
    let fields = forgot_fields;
    if (stage === 1) fields = fields.slice(0, 1);
    else if (stage === 2) fields = fields.slice(1, 2);
    else if (stage === 3) fields = fields.slice(2);

    // the navigation
    const navigate = useNavigate();

    // handle the input change
    const handle_change = event => set_forgot({...forgot, [event.target.id]: event.target.value});

    // mask the email
    const mask_email = email => {
        const [local, domain] = email.split("@");
        const visible = local.slice(0, 2);
        const masked = "*".repeat(local.length - 2);
        return `${visible}${masked}@${domain}`;
    };

    // handle the submit
    const handle_submit = event => {
        event.preventDefault();
        set_is_disable(true);

        // prepare the query
        const endpoint = USER_API + "auth.php";
        const data = {...forgot, stage};

        // send the query to the server
        axios.post(endpoint, data).then(response => {
            const {data} = response;
            if (data.success){

                // update the stage
                if (stage === 1){
                    set_stage(preview => preview + 1);
                    set_alert({type: "success", text: "code sent successfully"});
                }
                else if (stage === 2){
                    set_stage(preview => preview + 1);
                    set_alert({type: "success", text: "the code is correct"});
                }
                else if (stage === 3){
                    navigate("/login");
                    set_alert({type: "success", text: "the password is changed"});
                };
            }

            // if the error occured
            else if (data.error) set_alert({type: "error", text: data.error});
            set_is_disable(false);
        });
    };

    // start or restart the cooldown
    const start_cooldown = () => {
        set_is_disabled_resend(true);
        if (timer_ref.current) clearTimeout(timer_ref.current);
        timer_ref.current = setTimeout(() => {
            set_is_disabled_resend(false);
        }, 60000);
    };
    useEffect(() => {
        start_cooldown();
        return () => timer_ref.current && clearTimeout(timer_ref.current);
    }, []);

    // handle the resend
    const handle_resend = event => {
        event.preventDefault();
        start_cooldown();

        // prepare the query
        const endpoint = USER_API + "auth.php";
        const data = {...forgot, stage: "resend"};

        // send the query to the server
        axios.post(endpoint, data).then(response => {
            const {data} = response;
            if (data.success){
                set_alert({type: "success", text: "the code resent"});
            }

            // if the error occured
            else if (data.error){
                if (timer_ref.current) clearTimeout(timer_ref.current);
                set_is_disabled_resend(false);
                set_alert({type: "error", text: data.error});
            }
        });
    };

    // return to the component data
    return (
        <>
            <OuterHeader special_buttom={false} />
            <div className="-m-5 h-[calc(100vh-80px)] flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                <Alerter />

                <div className="max-w-md w-full space-y-8 p-4">
                    <Header
                        heading={stage === 1 ? "Forgot Your Password" : stage === 2 ? "Authentication" : "Change Your Password"}
                        paragraph={stage === 1 ? "Remember's your password?" : stage === 2 && "A verification code was sent to"}
                        link_name={stage === 1 && "Login"}
                        paragraph_extra={stage === 2 && mask_email(forgot.mail)}
                        link_url="/login"
                    />

                    <form className="space-y-4" onSubmit={handle_submit}>
                        <div>
                            {fields.map(field => 
                                <Input
                                    key={field.id}
                                    input_data={field}
                                    handle_change={handle_change}
                                    value={forgot[field.id]}
                                />
                            )}
                        </div>

                        {stage === 2 && <div className="flex justify-start items-center text-sm gap-x-2 ml-2">
                            <p className="text-gray-700 dark:text-gray-200">Did't recieve code?</p>
                            <button type="button" disabled={is_disabled_resend} onClick={handle_resend} className="text-primary disabled:text-gray-400 dark:disabled:text-gray-500 font-semibold">Resend code</button>
                        </div>}

                        <FormAction text={stage !== 3 ? "Send" : "Change"} />
                    </form>
                </div>
                <Footer copy={false} />
            </div>
        </>
    );
};
export default Forgot;